import React, { useEffect, useState } from "react";
import "./login.css";
import CustomInput from "../../ui/inputs";
import Spacer from "../../ui/spacer";
import { AppColors } from "../../utils/global-constants";
import MainButton from "../../ui/main-button";
import {
  auth,
  signInWithEmailAndPassword,
  doc,
  collection,
  getDoc,
  db,
} from "../../utils/firebase-config";
import toast from "react-hot-toast";
import { setCurrentUser } from "../../redux/actions";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const _loginHandler = () => {
    if (rememberMe) {
      localStorage.setItem("user_email", email);
    } else {
      localStorage.removeItem("user_email");
    }
    setLoading(true);

    toast
      .promise(signInWithEmailAndPassword(auth, email, password), {
        loading: "Logging in...",
        success: "Logged in successfully",
        error: "Login failed, please try again",
      })
      .then((userCredential) => {
        console.log(userCredential.user);
        const user = doc(
          collection(db, "hardPackUsers"),
          userCredential.user.uid
        );
        setTimeout(() => {
          getDoc(user).then((doc) => {
            console.log(doc.data());
            dispatch(setCurrentUser(doc.data()));
            setTimeout(() => {
              navigate("/home");
            }, 500);
          });
        }, 1000);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  useEffect(() => {
    try {
      console.log(auth.currentUser);
    } catch (error) {
      console.log(error);
    }
    if (localStorage.getItem("user_email")) {
      setEmail(localStorage.getItem("user_email"));
      setRememberMe(true);
    }
    const userid = localStorage.getItem("user_id");
    if (userid) {
      navigate("/home");
    }
  }, [navigate]);
  return (
    <div className="login-container">
      <div className="login-container-content">
        <div className="login-container-content-wrapper">
          <p className="login-container-content-wrapper-title">Login</p>
          <Spacer />
          <CustomInput
            placeholder="Email"
            label="Email"
            icon="mail"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
          />
          <Spacer />
          <div className="login-container-content-wrapper-remember-me">
            <p style={{ color: AppColors.main }}>Remember Me</p>
            <input
              className="login-container-content-wrapper-remember-me-checkbox"
              type="checkbox"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
          </div>
          <Spacer />
          <CustomInput
            placeholder="Password"
            password
            label="Password"
            icon="lock-closed"
            onChange={(e) => setPassword(e.target.value)}
            value={password}
          />
          <Spacer />
          <div className="login-container-content-wrapper-forgot-password">
            <p style={{ color: AppColors.main }}>Forgot Password?</p>
          </div>
          <Spacer height={40} />
          <MainButton
            text="Login"
            onClick={_loginHandler}
            loading={loading}
            disabled={loading}
          />
          <div
            className="login-container-content-wrapper-signup"
            onClick={() => navigate("/signup")}
          >
            <p style={{ color: AppColors.white }}>Don't have an account?</p>
            <p style={{ color: AppColors.main, marginLeft: "5px" }}>Sign Up</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
